module.exports = __webpack_public_path__ + "img/facilities_06.ca229078.jpg";